import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { buildPredictedVolumeCapsuleConfigSlice } from './config/configslice';
import { PredictedVolumeCapsuleState } from './PredictedVolumeCapsuleState';
import { PredictedVolumeCapsuleActionPayload } from './actions';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const capsuleStateReducer = (widgetType: WidgetType) =>
    combineReducers<PredictedVolumeCapsuleState>({
        config: buildPredictedVolumeCapsuleConfigSlice(widgetType).reducer,
    });

export const predictedVolumeCapsuleReducer = createWidgetsReducer<
    PredictedVolumeCapsuleState,
    PredictedVolumeCapsuleActionPayload
>(
    WidgetType.PREDICTED_VOLUME_CAPSULE,
    capsuleStateReducer(WidgetType.PREDICTED_VOLUME_CAPSULE)
);

export const predictedCloseVolumeCapsuleReducer = createWidgetsReducer<
    PredictedVolumeCapsuleState,
    PredictedVolumeCapsuleActionPayload
>(
    WidgetType.PREDICTED_CLOSE_VOLUME_CAPSULE,
    capsuleStateReducer(WidgetType.PREDICTED_CLOSE_VOLUME_CAPSULE)
);
